export interface IApiUser {
  email: string;
  name: string | null;
  lastName: string | null;
  color: string | null;
  enabled?: boolean;
}
export interface IUserName extends IApiUser {
  userName: string;
}

export interface IGuestUser {
  email: string;
}

export const DELETED_USER: IUserName = {
  userName: '',
  name: '-',
  lastName: '',
  email: '',
  color: '#ccc',
  enabled: false
};

export enum SsoProvider {
  google = 'Google',
  microsoft = '' // It is expected
}

export enum MfaMode {
  TOTP = 'TOTP'
}
